// this script triggers the login wall
//
// how to use on a page:
// use the following attributes für single elements (e.g. buttons or links) or for a whole section (div, ...)
// data-login-wall-activate, data-login-wall-prevent-action, data-login-wall-exclude
//
// to stop links and other actions AND open the login layer, when click is on an a-tag or button-tag
// add the attribute
// data-login-wall-prevent-action
//
// to prevent the login wall to be triggered on an element or any child element
// add the attribute
// data-login-wall-exclude
//
// to ACTIVATE the login wall on the page you must
// add the attribute
// data-login-wall-activate
// ANYWHERE on the page (e.g. in a wrapper div)
// this way you use the login wall on defined pages only,
// e.g. on product detail pages or category pages, you use the attribute data-login-wall-activate in the main wrapper of the vue component
// it can be used in any vue-file, in any component (even in a html-hybris-component), in any jsp, ...
//
// if there is no element with the attribute data-login-wall-activate on the page, the login wall will not be activated

import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";
import loginPopup from "@JS/shop/10-login-component/loginPopup";

/** @type {string|null} */
let _selectedLayerName;

// eslint-disable-next-line complexity
const init = function () {
	// 1. Check if the page is a LandingPage or DepartmentPage
	// not absolutely necessary, but this way no EventListner is set on LandingPages and DepartmentPages
	const bodyElement = document.body;
	const isExcludedPage = bodyElement.classList.contains("pageType-LandingPage");
	if (isExcludedPage) return;

	// 2. Check if the page has a Login Layer
	const commonLayerElement = document.querySelector("#master-common-layer");
	if (!commonLayerElement) return;

	_selectedLayerName = commonLayerElement.dataset.layerselected || null;

	if (_selectedLayerName && ["Registration", "LoginRegistration"].includes(_selectedLayerName)) {
		loginPopup.init();
		_initializeLoginLayer();
	}
};

const _initializeLoginLayer = function () {
	// 1. Check for URL Parameter to open Login Layer on load
	const openLayerOnLoad = getParam("openLayer") !== null;
	if (openLayerOnLoad) _openPopup(true);

	// 2. Add general click handler to block links and open Login Layer
	// only add loginWall Eventlistener when user is authlevel===0
	const authLevel = window.recommendationData?.Recommendation?.customerData?.authlevel || 0;
	if (authLevel > 0) return;
	document.addEventListener("click", checkLoginWall, true);
};

const checkLoginWall = (event) => {
	// Check if login wall is active on this page:
	const pageUsesLoginWall = document.querySelector("[data-login-wall-activate]");
	if (!pageUsesLoginWall) return;

	const closestExclude = event.target.closest("[data-login-wall-exclude]");
	const closestLoginWall = event.target.closest("[data-login-wall-prevent-action]");

	// If there is no closestLoginWall or the closestLoginWall contains the closestExclude, do nothing
	if (!closestLoginWall || (closestExclude && closestLoginWall.contains(closestExclude))) return;

	event.stopPropagation();
	event.preventDefault();

	// Open Login Layer if clicked Element is a-Tag or button-Tag
	const closestLink = event.target.closest("button, a");
	if (!closestLink) return;

	_openPopup(true);
};

const getParam = function (paramName) {
	return new URLSearchParams(window.location.search).get(paramName);
};

const _openPopup = function (isClosable = false) {
	OcmMessenger.publish(messengerPublicationTypes.REQUEST_LOGIN, { isClosable });
};

const loginWall = {
	init,
};

export default loginWall;
